import { render, staticRenderFns } from "./InputToggle.vue?vue&type=template&id=6bb8674f&"
import script from "./InputToggle.vue?vue&type=script&lang=ts&"
export * from "./InputToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports